import script from "./HorizontalLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./HorizontalLayout.vue?vue&type=script&setup=true&lang=js"

import "./HorizontalLayout.vue?vue&type=style&index=0&id=3abfbf4c&lang=scss"

const __exports__ = script;

export default __exports__